import React, { useState } from "react";
import { motion } from "framer-motion";
import Layout from "../../../layout/Layout";
import Lottie from "lottie-react";

import fontAnimation from "../../../animations/companyManagement/font.json"
import themeAnimation from "../../../animations/companyManagement/theme.json"
import permissionsAnimation from "../../../animations/companyManagement/permissions.json"
import addUserAnimation from "../../../animations/companyManagement/addUser.json"
import activityLogAnimation from "../../../animations/companyManagement/activityLog.json"


function CompanyManagement() {
  return (
    <Layout>
    {/*Hero section */}
    <section className="relative bg-[#0A0F1F] text-white py-10 mt-28 overflow-hidden">

      {/* Main Content */}
      <div className="container mx-auto px-6 py-10 lg:flex lg:items-center lg:justify-between">
        {/* Left Section */}
        <div className="lg:w-1/1 text-center lg:text-left">
          <h1 className="font-larger mb-10">
          COMPANY MANAGEMENT
          </h1>
          <p className="mt-6 text-gray-300 max-w-md">
            <b>Take control of your business with customizable settings, user management, and detailed activity logs. 
            Your company's success starts here. </b></p>
          <div className="mt-8 flex justify-center lg:justify-start gap-4">
            <button className="px-8 py-3 bg-yellow-400 text-gray-900 font-semibold rounded-md shadow-md hover:bg-yellow-300 transition">
              Get Started
            </button>
          </div>
          
        </div>

        {/* Right Section */}
        <div className="lg:w-2/3 relative">

          
        </div>
      </div>
    </section>


    <section className="relative text-white py-0 overflow-hidden">

      <div className="container mx-auto px-6 py-0 ">

      {/* Company Management Features Section */}
      <section className=" py-16">
        <div className="container mx-auto mb-10 px-6 text-center">
          <h1 className="text-4xl font-bold text-cyan-400">
            Tailor Your Company’s Identity
          </h1>
          <p className="mt-4 text-lg text-gray-300">
            From logo to document themes, everything you need to brand your business.
          </p>
        </div>
        <div className="container mx-auto px-6 grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Feature 1: Toggle Settings */}
          <div className="text-left p-6 border border-dotted border-12 rounded-lg shadow-lg">
            <h2 className="text-xl font-bold text-yellow-400">Company Settings</h2>
            <p className="mt-4 text-gray-300">
              Set your preferred company settings and see them reflected on all system generated documents
            </p>
            <div className="mt-6 grid grid-cols-2 gap-4">
                <Lottie animationData={fontAnimation} loop={true} />
                <Lottie animationData={themeAnimation} loop={true} />
            </div>
          </div>

          {/* Feature 2: Logo */}
          <div className="text-left p-0 grid grid-rows-1 md:grid-rows-2 rounded-lg shadow-lg gap-8">
            
            {/* Feature 3: Branding Preview */}
            <div className="p-6 border border-dotted border-12 rounded-lg shadow-lg">
                <h2 className="text-xl font-bold text-green-400">Custom Logo</h2>
                <p className="mt-4 text-gray-300">
                    Add your company logo to personalize all generated documents.
                </p>
            </div>
            {/* Feature 3: Branding Preview */}
            <div className="p-6 border border-dotted border-12 rounded-lg shadow-lg">
                <h2 className="text-xl font-bold text-purple-400">Document Branding</h2>
                <p className="mt-4 text-gray-300">
                    Customize the appearance of invoices and other documents.
                </p>
            </div>
            
          </div>

          
        </div>
      </section>

      {/* User Management Features Section */}
      <section className=" py-16 mt-10">
        <div className="container mx-auto mb-10 px-6 text-center">
          <h1 className="text-4xl font-bold text-cyan-400">
            Manage platform users
          </h1>
          <p className="mt-4 text-lg text-gray-300">
           Easily add users, manage permissions, and monitor activity across your platform.   
          </p>
        </div>
        <div className="container mx-auto px-6 grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Feature 1: Add User */}
              <div className="text-left border border-dotted border-12 p-6 rounded-lg shadow-lg">
                <h2 className="text-xl font-bold text-yellow-400">Add Users</h2>
                <p className="mt-4 text-gray-300">
                  Quickly onboard new team members with a seamless user addition process.
                </p>
                <div className="mt-6 flex justify-center items-center">
                  <Lottie animationData={addUserAnimation} loop={true} />
                </div>
              </div>

              {/* Feature 2: Manage Permissions */}
              <div className="text-left p-6 rounded-lg shadow-lg">
                <h2 className="text-xl font-bold text-green-400">Manage Permissions</h2>
                <p className="mt-4 text-gray-300">
                  Assign roles and permissions to ensure secure and efficient platform usage.
                </p>
                <div className="mt-6">
                  <Lottie animationData={permissionsAnimation} loop={true} />
                </div>
              </div>

              {/* Feature 3: Activity Logs */}
              <div className="text-left p-6 border border-dotted border-12 rounded-lg shadow-lg">
                <h2 className="text-xl font-bold text-purple-400">Activity Logs</h2>
                <p className="mt-4 text-gray-300">
                  Monitor and audit user activities for enhanced security and compliance.
                </p>
                <div className="mt-6">
                <Lottie animationData={activityLogAnimation} loop={true} />
                </div>
              </div>
        </div>
      </section>

     
        </div>
        </section>
    </Layout>
  );
}

export default CompanyManagement;

